import { Dispatch } from 'redux';
import { ActionTypes, ReduxAction } from './types';
import { Benutzer, RegistrierungService } from '../../api';
import { History } from 'history';
import { setNotification } from '../../utils/notificationUtils';
import { INFO } from '../../layouts/notification/Notification';

export const getRegLaender = () => async (dispatch: Dispatch<ReduxAction>) => {
  new RegistrierungService().getAllLkz().then(result => {
    dispatch({
      type: ActionTypes.GET_LAENDER_REG,
      payload: result.data,
    });
  });
};

export const getRegOrte =
  (lkz: string, plzOrOrtsname: string) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    new RegistrierungService()
      .searchOrtWithPlzOrName(lkz ?? '', plzOrOrtsname)
      .then(result => {
        dispatch({
          type: ActionTypes.GET_ORTE_REG,
          payload: result.data,
        });
      });
  };

export const getRegSprachen = () => async (dispatch: Dispatch<ReduxAction>) => {
  new RegistrierungService().getSprachen().then(result => {
    dispatch({
      type: ActionTypes.GET_SPRACHEN,
      payload: result.data,
    });
  });
};

export const register =
  (benutzer: Benutzer, history: History) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    //Registrierung
    new RegistrierungService().registerNewUser(benutzer).then(result => {
      setNotification(
        'Der Benutzer ' + benutzer.name + ' wurde erfolgreich angelegt.',
        [],
        INFO,
        10000
      );
      history.push('/');
    });
  };
